/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    setArticles(state, data) {
        state.articles = data
    },
    setArticle(state, data) {
        state.article = data
    },
    setArticlesConfig(state, data) {
        state.articlesConfig = data
    },
    setCategories(state, data) {
        state.categories = data
    },
    setCategoriesConfig(state, data) {
        state.categoriesConfig = data
    }
}
